import React from "react";
import { Link } from "react-router-dom";

const SubMenuMobile = ({ data, open, closeMenu }) => {
  if (!open) return null;

  return (
    <div className="mb-3">
      {data?.sub_link?.map((subLinkItem, subLinkIdx) => {
        const { screen, link } = subLinkItem;
        return (
          <Link
            key={subLinkIdx}
            to={link}
            onClick={closeMenu}
            className="w-full py-2 inline-block relative text-left z-40 hover:bg-gray-100 pl-10"
          >
            <span className="text-xs font-semibold uppercase">{screen}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default SubMenuMobile;
